let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cz9Ah")).then(() => parcelRequire('64AA8'));